import { combineEpics } from 'redux-observable';

import cashierEpic from './cashier';
import homeEpic from './home';
import openMiniLobbyEpic from './minilobby';
import payouts from './payouts';
import responsibleGamingEpic from './responsibleGaming';

export default combineEpics(
  cashierEpic,
  homeEpic,
  responsibleGamingEpic,
  openMiniLobbyEpic,
  payouts
);
